// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1kYW4","label":"Section_label__Gy4ha","contentWrap":"Section_contentWrap__2Gj0b","footer":"Section_footer__XT6VD","footerInner":"Section_footerInner__3C8GY"};